import React, { useLayoutEffect } from 'react';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import TrackingSection from './components/TrackingSection';
import AboutServicesSection from './components/AboutServicesSection';
import NetworkSection from './components/PartnersSection';
import NewsSection from './components/NewsSection';
import Footer from './components/Footer';
import AppDownloadSection from './components/AppDownloadSection';

const HomePage: React.FC = () => {
  useLayoutEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            (entry.target as HTMLElement).setAttribute('data-visible', 'true');
            observer.unobserve(entry.target);
          }
        });
      },
      // rootMargin top/bottom lớn → detect elements nằm trong viewport ngay khi mount
      { threshold: 0, rootMargin: '200px 0px 200px 0px' }
    );

    // Mark html element so CSS guard activates opacity:0 only after observer is ready
    document.documentElement.classList.add('js-animations-ready');

    // Watch all reveal & stagger targets
    document
      .querySelectorAll('[data-reveal], [data-stagger]')
      .forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <>
      <Header />
      <HeroSection />
      <TrackingSection />
      <AboutServicesSection />
      <NetworkSection />
      <AppDownloadSection />
      <NewsSection />
      <Footer />
    </>
  );
};

export default HomePage;
